<template>
  <div>
    <b-breadcrumb :items="$options.breadcrumb" class="d-none d-lg-flex" />

    <div class="d-flex align-items-center justify-content-between">
      <h2 class="d-none d-lg-block">Tellergroepen</h2>
      <b-btn variant="success" @click="showCreate = true">
        <span class="mdi mdi-plus-thick" /> Tellergroep toevoegen
      </b-btn>
    </div>

    <table-wrap :query="$options.query" small :fields="$options.fields">
      <template #cell(actions)="{item}">
        <b-btn size="sm" @click="edit = item.id"><span class="mdi mdi-pencil"/> Bewerken</b-btn>
      </template>
    </table-wrap>

    <b-modal v-model="showCreate" title-class="font-weight-bold" title="Tellergroep maken" centered no-close-on-backdrop>
      <edit-cgroup ref="createCgroup"/>
      <template v-slot:modal-footer="{ok, cancel}">
        <b-btn @click="cancel">Annuleer</b-btn>
        <b-btn @click="$refs.createCgroup.create(ok)" variant="primary">Opslaan</b-btn>
      </template>
    </b-modal>

    <b-modal v-model="showEdit" title-class="font-weight-bold" title="Tellergroep aanpassen" centered no-close-on-backdrop>
      <edit-cgroup ref="editCGroup" :id="edit"/>
      <template v-slot:modal-footer="{ok, cancel}">
        <b-btn @click="cancel">Annuleer</b-btn>
        <b-btn @click="$refs.editCGroup.saveEdit(ok)" variant="primary">Opslaan</b-btn>
      </template>
    </b-modal>

  </div>
</template>

<script>
import TableWrap from '@/components/TableWrap';
import EditCgroup from '@/components/EditCgroup';
import actionField from '@/lib/actionField';
export default
{
    components: {TableWrap, EditCgroup},
    computed:
    {
        showEdit:
        {
            get() { return this.edit !== null },
            set(val) { this.edit = val ? this.edit : null }
        }
    },
    data()
    {
        return {
            showCreate: false,
            edit: null
        }
    },
    query: require('../../graphql/live/admin_list_cgroups.gql'),
    breadcrumb:
    [
        {text: 'Configuratie'},
        {text: 'Tellergroepen'}
    ],
    fields:
    [
        {
            key: 'displayName',
            label: 'Naam op factuur'
        },
        {
            key: 'description',
            label: 'Beschrijving'
        },
        {
            key: 'type',
            label: 'Type'
        },
        actionField
    ]
}
</script>

<style scoped>

</style>